module.exports = __webpack_public_path__ + "static/media/tick.9804068f.svg";